import { Asset, ASSET_TYPE } from "../types/types";

export class AssetManager {
  private _assets: { [key: string]: Asset };

  constructor() {
    this._assets = {};
  }

  getAsset(id: string): Asset {
    if (!(id in this._assets)) {
      throw new Error(`asset '${id}' not found`);
    }
    return this._assets[id];
  }

  addAsset(asset: Asset) {
    if (asset.id in this._assets) {
      throw new Error(`asset '${asset.id}' already exists`);
    }
    this._assets[asset.id] = asset;
  }

  deleteAsset(id: string) {
    if (!(id in this._assets)) {
      throw new Error(`asset '${id}' not found`);
    }
    delete this._assets[id];
  }
}
